/**
 * CSS styles to hide scrollbars while maintaining scroll functionality
 * Works across all major browsers (Chrome, Safari, Firefox, Edge, IE)
 */
export const hiddenScrollbarStyles = {
    "&::-webkit-scrollbar": {
        display: "none",
    },
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
} as const
